import fetch from 'utils/fetch';

export const update = (id, json) => {
  return fetch(`/pco-manager/aast/cases/contract/${id}/renew`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};

export const validate = (id, json) => {
  return fetch(`/pco-manager/aast/cases/contract/${id}/renew/validate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json, (key, value) => {
      return value === '' ? undefined : value;
    }),
  });
};



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/api/index.js